import React from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    Typography, 
    IconButton 
} from '@material-ui/core';
import { Close as CloseIcon, Save as SaveIcon, ExitToApp as ExitIcon } from '@material-ui/icons';

const SavedExitModal = ({ 
    open = true, 
    onClose, 
    onSaveAndExit, 
    onExitWithoutSaving,
    title = "Unsaved Changes",
    message = "You have unsaved changes. What would you like to do?"
}) => {
    
    const handleSaveAndExit = () => {
            onSaveAndExit();
    };

    const handleExitWithoutSaving = () => {
            onExitWithoutSaving();

    };

    const handleClose = () => {
            onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="saved-exit-modal-title"
            aria-describedby="saved-exit-modal-description"
            maxWidth="sm"
            fullWidth
            className="saved-exit-modal"
        >
            <DialogTitle id="saved-exit-modal-title" className="saved-exit-modal-title">
                <Typography variant="h6" component="div" style={{ flexGrow: 1, textAlign: 'center'  }}>
                    {title}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    style={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            
            <DialogContent className="saved-exit-modal-content" style={{ textAlign: 'center', paddingBottom: '24px' }}>
                <Typography id="saved-exit-modal-description" variant="body1" style={{ marginBottom: '24px' }}>
                    {message}
                </Typography>
            </DialogContent>
            
            <DialogActions className="saved-exit-modal-actions" style={{ justifyContent: 'center', marginBottom: '12px' }}>
                <Button
                    onClick={handleSaveAndExit}
                    color="primary"
                    variant="contained"
                    startIcon={<SaveIcon />}
                    style={{ backgroundColor: "#379811" }}
                >
                    Save & Exit
                </Button>
                <Button
                    onClick={handleExitWithoutSaving}
                    color="secondary"
                    variant="contained"
                    startIcon={<ExitIcon />}
                >
                    Exit Without Saving
                </Button>
                <Button
                    onClick={handleClose}
                    color="secondary"
                    variant="outlined"
                >
                    Continue Editing
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SavedExitModal;